import Icon from '@/components/base/Icon';
import clsx from 'clsx';
import type { SocialProfileNetworkType } from '@/types/socialProfileType';
import type { FutureNetworkType } from '@/types/FutureNetworkType';

//components
import Instagram from '@/components/icons/Instagram';
import { YoutubeIcon } from '@/components/icons/Networks/YoutubeIcon';
import { PinterestIcon } from '@/components/icons/Networks/PinterestIcon';
import { GoogleAnalyticsIcon } from '@/components/icons/Networks/GoogleAnalyticsIcon';
import { BlueSkyIcon } from '@/components/icons/Networks/BlueSkyIcon';
import { GoogleBusinessIcon } from '@/components/icons/Networks/GoogleBusinessIcon';
import { MastodonIcon } from '@/components/icons/Networks/MastodonIcon';
import { QuoraIcon } from '@/components/icons/Networks/QuoraIcon';
import { RedditIcon } from '@/components/icons/Networks/RedditIcon';
import { SnapchatIcon } from '@/components/icons/Networks/SnapchatIcon';
import { ThreadsIcon } from '@/components/icons/Networks/ThreadsIcon';
import { TwitchIcon } from '@/components/icons/Networks/TwitchIcon';
import { WhatsAppIcon } from '@/components/icons/Networks/WhatsAppIcon';
import { WeChatIcon } from '@/components/icons/Networks/WeChatIcon';
import { TelegramIcon } from '@/components/icons/Networks/TelegramIcon';

type NetworkIconProps = {
    network: FutureNetworkType | SocialProfileNetworkType;
} & React.ComponentPropsWithRef<'svg'>;

export function NetworkIcon({ network, ...restProps }: NetworkIconProps) {
    if (network === 'youtube') return <YoutubeIcon {...restProps} />;
    if (network === 'pinterest') return <PinterestIcon {...restProps} />;
    if (network === 'google_analytics') return <GoogleAnalyticsIcon {...restProps} />;
    if (network === 'whats_app') return <WhatsAppIcon {...restProps} />;
    if (network === 'threads') return <ThreadsIcon {...restProps} />;
    if (network === 'snapchat') return <SnapchatIcon {...restProps} />;
    if (network === 'google_business') return <GoogleBusinessIcon {...restProps} />;
    if (network === 'twitch') return <TwitchIcon {...restProps} />;
    if (network === 'mastodon') return <MastodonIcon {...restProps} />;
    if (network === 'bluesky') return <BlueSkyIcon {...restProps} />;
    if (network === 'we_chat') return <WeChatIcon {...restProps} />;
    if (network === 'telegram') return <TelegramIcon {...restProps} />;
    if (network === 'reddit') return <RedditIcon {...restProps} />;

    if (network === 'instagram') return <Instagram {...restProps} />;

    if (['facebook', 'twitter', 'linkedin', 'tiktok_business'].includes(network)) {
        return (
            <Icon
                icon={network}
                className={clsx(restProps.className, 'dark:text-white', {
                    'text-facebook': network === 'facebook',
                    'text-linkedin': network === 'linkedin',
                    'text-twitter': network === 'twitter',
                    'text-tiktok': network === 'tiktok_business'
                })}
            />
        );
    }

    return <QuoraIcon {...restProps} />;
}
